// This file contains the configuration for the project.
export const WEBSITE_ID = process.env.REACT_APP_WEBSITE_ID || "example1";


